import React, { useEffect, useState } from 'react';
import { Card, Table, Tag, DatePicker, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import api from '../utils/api';
import { PLEDGES } from '../components/WelcomePledge';

const { Text } = Typography;

export default function PledgeLog() {
  const [date, setDate] = useState(dayjs());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get('/pledge/log', { params: { date: date.format('YYYY-MM-DD') } })
      .then(r => setRows(r.data?.rows || [])).catch(() => setRows([])).finally(() => setLoading(false));
  }, [date]);

  const done = rows.filter(r => r.accepted_at).length;

  return (
    <Card title={<Space>Staff Sankalp — {done}/{rows.length} ne tick kiya</Space>}
      extra={<DatePicker value={date} onChange={(d) => d && setDate(d)} allowClear={false} />}>
      <div style={{ marginBottom: 12 }}>
        {PLEDGES.map((p, i) => <div key={i}><Text type="secondary">{i + 1}. {p}</Text></div>)}
      </div>
      <Table rowKey="id" loading={loading} dataSource={rows} pagination={false} size="small"
        columns={[
          { title: 'Staff', render: (_, r) => <b>{r.full_name || r.username}</b> },
          { title: 'Role', dataIndex: 'role' },
          { title: 'Status', render: (_, r) => r.accepted_at
            ? <Tag color="green">Tick kiya — {dayjs(r.accepted_at).format('hh:mm A')}</Tag>
            : <Tag>Aaj login nahi kiya</Tag> },
        ]} />
    </Card>
  );
}
